site.nav = {
	// Init navigation scripts
	init: function() {
		var $html = $('<div id="mMenu" role="navigation"></div>');
		var $mMenu = $('#mainmenu').clone().removeAttr('id').attr('role','navigation');
		$mMenu.find('ul').removeAttr('id');
		$('ul.mmLevel1:gt(0)',$mMenu).remove().children('li').appendTo($('ul.mmLevel1:eq(0)',$mMenu));
		$html.append($mMenu);
		$('body').append($html);

		// Add expand link to mobile menu
		$('.children', '#mMenu').prepend('<span class="expand"><span class="first"></span><span class="last"></span></span>');
		$('.selectedLevel1','#mMenu').addClass('down');
		$('.selectedLevel2','#mMenu').addClass('down');
		$('.selectedLevel3','#mMenu').addClass('down');
		$('.selectedLevel4','#mMenu').addClass('down');
		//$('.selectedLevel2.children', '#mainmenu2').addClass('down');

		//$('.level2 > a', '.box_info, #mainmenu2').prepend('<span class="expand"><i class="fa fa-caret-right"></span>');
		site.nav.bind();
		//site.nav.appendLanguage();
		site.nav.appendQuickNav();
		site.nav.appendSearchBox();
	},
	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').on('click touchStart',function(e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mainmenu-open');
			site.nav.mobileToggle(e, menuOpen);

			$('#mMenu').on('click touchStart', function(e) {
				e.stopPropagation();
			});

			$('body.mainmenu-open').on('click touchStart', function (e) {
				$('body').removeClass('mainmenu-open');
			});
		});

		// Expand in mobile menu
		$('.expand', '#mMenu').bind('click touchStart', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
		/*
		$('#mainmenu2 .children .expand').bind('click', function(e) {
			console.log('asdf');
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
		*/
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
	},
	// Append language to site
	appendLanguage: function() {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function() {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	},
	appendQuickNav: function() {
		var $qn = $('#mainmenu .languages');//.clone();
		var $menu = $('ul.mmLevel1', '#mMenu');
		var $qnContent = '';

		$qn.find('li').each(function() {
			$qnContent += '<li class="lang level1">'+$(this).clone().html()+'</li>';
			//$menu.append($(this).addClass('ele-qn si level1'));
		});
		$menu.append($qnContent);
	},
	appendSearchBox: function() {
		var $mmenu = $('#mMenu'),
			$mSearchBox = $('#searchBox').clone().removeAttr('id').attr('id','mSearchBox');
		$mmenu.prepend($mSearchBox);

		$('[id]', $mSearchBox).each(function() {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'm'+$id.substr(0,1).toUpperCase()+$id.substr(1),
				$label = $('label[for="'+$id+'"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);

			/*
			if (typeof $this.attr('name') !== typeof undefined) {
				$this.attr('name', $newId);
			}
			*/
		});
	}
};

site.inits.push('site.nav.init()');
